import React from 'react';

import { View } from '@applane/react-core-components';

import { ScreenContextProvider } from '../../app-components/screen/ScreenContextProvider';
// import { NotificationContextProviderHoc } from '../../AppNotification';
import { getUser } from '../../AppServices';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

const AppContainer = (props) => {
  const { children, ...restProps } = props;
  const user = getUser();

  const wrappedComponent = (
    <View style={{ flex: 1, overflow: 'hidden', flexDirection: 'row' }}>
      <View style={{ overflow: 'hidden' }}>
        <ScreenContextProvider>
          <Sidebar {...restProps} user={user} />
        </ScreenContextProvider>
      </View>
      <View style={{ flex: 1, overflow: 'hidden' }}>
        <ScreenContextProvider>
          <Header {...restProps} user={user} />
          <View
            style={{
              flex: 1,
              overflow: 'hidden',
            }}
          >
            {children}
          </View>
          <Footer {...restProps} />
        </ScreenContextProvider>
      </View>
    </View>
  );

  // if (user) {
  //   wrappedComponent = (
  //     <NotificationContextProviderHoc
  //       navigation={restProps.navigation}
  //       eventDispatcher={restProps.eventDispatcher}
  //     >
  //       { wrappedComponent }
  //     </NotificationContextProviderHoc>
  //   );
  // }
  return wrappedComponent;
};

export default AppContainer;
